export default __webpack_public_path__ + "static/media/AMEX.169edd5a.svg";